// Import required libraries
import React, { useState } from "react";
import Popover from "@material-ui/core/Popover";
import { useMsal } from "@azure/msal-react";

// Import custom components

// Import styles
import "./UserInfo.scss";

// Import config
import { config } from "../../config/config";

function UserInfo(props) {
  const { instance } = useMsal();
  let { user } = props;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const logout = () => {
    // const accounts = instance.getAllAccounts();

    // Trigger Microsoft logout via redirect
    instance.logoutRedirect({
      // account: accounts[0],
      postLogoutRedirectUri: config.api.redirect_Uri,
      onRedirectNavigate: (url) => {
        // Clear storage right before redirecting in your app
        localStorage.clear();
        sessionStorage.clear();

        // This skips the Microsoft logout confirmation page
        window.location.href = config.api.redirect_Uri;
        return false;
      },
      // logoutHint: accounts[0]?.username,
    });
  };

  return (
    <div className="user-info-container">
      <i
        className="material-icons-outlined header-menu-icon"
        aria-owns={open ? "mouse-over-popover" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        {" "}
        person{" "}
      </i>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          style: { width: "15%" },
        }}
      >
        <div className="user-info-name">
          <p className="user-info-text">{user.displayName}</p>
        </div>
        <div className="user-info-sign-out">
          <p
            className="user-info-sign-out-text"
            onClick={() => {
              logout();
            }}
          >
            Sign Out
          </p>
        </div>
      </Popover>
    </div>
  );
}

export default UserInfo;
